export function isActivationKey(key: string): boolean {
  return key === "Enter" || key === " ";
}

export const numberKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
export const letterKeys = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];
